import Yucatan from "../yucatan";
import { SVGMap } from "react-svg-map";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import BtnLetters from "./BtnLetters";
// import { logoyuc } from './../assets/logo-congreso.png';

function Mapa() {
  const navigate = useNavigate();
  const [tooltipStyle, setTooltipStyle] = useState({
    display: "none",
  });
  const [pointedLocation, setPointedLocation] = useState(null);

  const onClick = (id) => {
    navigate(process.env.PUBLIC_URL + "/" + id);
  };

  const onHover = (name) => {
    setPointedLocation(
      <div>
        <h4 className="mb-0">{name}</h4>
        {/* <p>Obras: </p> */}
      </div>
    );
  };

  const onMouseMove = (event) => {
    const tooltipStyle = {
      display: "block",
      top: event.clientY + 10,
      left: event.clientX - 100,
    };
    setTooltipStyle(tooltipStyle);
  };

  const onMouseOut = () => {
    setPointedLocation(null);
    setTooltipStyle({ display: "none" });
  };

  const date = Date.now();

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-5 p-1 selecciona">
            <div className="row">
              <div className="col-12 col-md-9">
                <img
                  id="btn-select"
                  src={require("../assets/btn-selecciona.png")}
                  className="img-fluid"
                  alt="Selecciona un sujeto obligado"
                />
              </div>
            </div>
            <div className="d-flex flex-row flex-md-column gap-1">
              <div className="col-xs-6 col-md-7">
                <div className="card card-img border-0 mb-2 mt-2">
                  <div className="card-body p-0">
                    <h5 className="card-title">
                      <img
                        src={require("../assets/ejecutivo-title.png")}
                        className="img-fluid"
                        alt="Poder Ejecutivo del Estado"
                      />
                    </h5>
                    <Link
                      to={`${process.env.PUBLIC_URL}/poder-ejecutivo-del-estado`}
                    >
                      <img
                        id="img-gobierno"
                        src={require("../assets/logo-yucatan-2024-2030.png")}
                        alt="Poder Ejecutivo del Estado de Yucatán"
                      />
                    </Link>
                    <p className="mb-0 mt-2 text-end">
                      <Link
                        to={`${process.env.PUBLIC_URL}/poder-ejecutivo-del-estado`}
                        className="btn btn-info text-white"
                      >
                        Ingresar
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xs-6 col-md-7">
                <div className="card card-img border-0 mb-2 mt-2">
                  <div className="card-body p-0">
                    <h5 className="card-title">
                      <img
                        src={require("../assets/congreso-title.png")}
                        className="img-fluid"
                        alt="H Congreso del Estado de Yucatán"
                      />
                    </h5>
                    <Link
                      to={`${process.env.PUBLIC_URL}/h-congreso-del-estado`}
                    >
                      <img
                        id="img-congreso"
                        src={require("../assets/logo-congreso-2024-2027.png")}
                        alt="Poder Ejecutivo del Estado de Yucatán"
                      />
                    </Link>
                    <p className="mb-0 mt-2 text-end">
                      <Link
                        to={`${process.env.PUBLIC_URL}/h-congreso-del-estado`}
                        className="btn btn-info text-white"
                      >
                        Ingresar
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-7 p-1 mapa-interactivo">
            <div className="d-flex gap-3">
              <div className="">
                <img
                  id="mpios-title"
                  src={require("../assets/btn-municipios-mapa-interactivo.png")}
                  className="img-fluid"
                  alt="municipios mapa interactivo"
                />
              </div>
              <div className="">
                <a
                  href={
                    "https://iepac.mx/public/documentos-del-consejo-general/acuerdos/iepac/2026/ACUERDO-C.G.006-2026.pdf?r=" +
                    date
                  }
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    id="btn-porcent"
                    src={require("../assets/btn-porcentajes.png")}
                    className="img-fluid"
                    alt="municipios mapa interactivo"
                  />
                </a>
              </div>
              <div className="">
                <a
                  href={
                    "https://iepac.mx/catalogo-de-politicas-publicas-2026.pdf?r=" +
                    date
                  }
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    id="btn-descarga"
                    src={require("../assets/btn-descarga-catalogo.png")}
                    className="img-fluid"
                    alt="¿Cómo solicito un plebiscito?"
                  />
                </a>
              </div>
            </div>
            <div>
              <SVGMap
                id="mapa"
                className="mapa"
                locationClassName="location"
                onLocationClick={(e) => onClick(e.target.id)}
                onLocationMouseOver={(e) =>
                  onHover(e.target.attributes.name.value)
                }
                onLocationMouseMove={onMouseMove}
                onLocationMouseOut={onMouseOut}
                map={Yucatan}
              />
              <div className="map_tooltip" style={tooltipStyle}>
                {pointedLocation}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BtnLetters />
    </>
  );
}

export default Mapa;
